<template>
  <div class="app-features">
    <span id="f-add-up">
      <AppFeaturesAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateId="updateId"
      ></AppFeaturesAddUpdate>
    </span>
    <va-card :title="$t('app-features.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#f-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="app_features"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="is_active" slot-scope="props">
          <va-toggle
            small
            :value="props.rowData.is_active"
            :label="props.rowData.is_active ? 'Sim' : 'Não'"
            @input="toggleActive(props.rowData)"
          />
        </template>
        <template slot="max_version_ios" slot-scope="props">
          {{ props.rowData.max_version_ios || $t('app-features.released') }}
        </template>
        <template slot="max_version_android" slot-scope="props">
          {{ props.rowData.max_version_android || $t('app-features.released') }}
        </template>
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('app-features.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#f-add-up"
              @click="update(props.rowData.id)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import AppFeaturesAddUpdate from './AppFeaturesAddUpdate'
const perPage = 10
export default {
  name: 'AppFeatures',
  components: { AppFeaturesAddUpdate },
  methods: {
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.app_features.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    toggleActive (row) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!, $is_active: Boolean!) {
              update_app_features_by_pk(pk_columns: {id: $id}, _set: {is_active: $is_active}) {
                id
              }
            }
          `,
          variables: {
            id: row.id,
            is_active: !row.is_active,
          },
        })
        .then(_ => {
          this.$apollo.queries.app_features.refetch()
          this.showToast(
            this.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.$apollo.queries.app_features.refetch()
          this.showToast(
            this.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    close (v) {
      this.showAdd = v
      this.updateId = null
    },
    update (id) {
      this.titleCard = 'update'
      this.updateId = id
      this.showAdd = true
    },
    open () {
      this.updateId = null
      this.showAdd = true
      this.titleCard = 'create'
    },
  },
  data () {
    return {
      perPage: perPage,
      app_features: [],
      page: 1,
      showAdd: false,
      pages: null,
      loading: false,
      titleCard: '',
      updateId: null,
    }
  },
  apollo: {
    app_features: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int) {
        app_features(limit: $perPage, offset: $page, order_by: {feature_key: asc}) {
          id
          feature_key
          name
          is_active
          max_version_ios
          max_version_android
        }
      }
      `,
      variables () {
        return {
          perPage: this.perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery {
        pages: app_features_aggregate{
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'feature_key',
        title: this.$t('app-features.headings.key'),
        width: '20%',
      }, {
        name: 'name',
        title: this.$t('app-features.headings.name'),
        width: '20%',
      }, {
        name: '__slot:is_active',
        title: this.$t('app-features.headings.active'),
        dataClass: 'text-center',
      }, {
        name: '__slot:max_version_ios',
        title: this.$t('app-features.headings.maxVersionIos'),
        dataClass: 'text-center',
      }, {
        name: '__slot:max_version_android',
        title: this.$t('app-features.headings.maxVersionAndroid'),
        dataClass: 'text-center',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('app_features')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.app_features.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
